'use client';

import { ArrowRight, CircleAlert } from 'lucide-react';
import { useRouter } from 'next/navigation';

import { Container } from '@/components/design/container';
import { Button } from '@/components/ui/button';
import useTranslation from '@/hooks/useTranslation';
import routes from '@/statics/routes';
import { getNotFoundRecoveryAction } from '@/utils/notFoundNavigation';

const NotFoundPage = (): React.ReactElement => {
  const router = useRouter();
  const { t } = useTranslation('pages.notFound');

  const handleRecover = (): void => {
    const action = getNotFoundRecoveryAction(window.history.length);

    if (action === 'back') {
      router.back();
      return;
    }

    router.push(routes.home.url);
  };

  return (
    <Container className="flex min-h-[calc(100dvh-340px)] items-center justify-center py-10">
      <div className="w-full max-w-[420px] rounded-[28px] border border-primary/10 bg-white/90 px-6 py-10 text-center shadow-[0_24px_80px_rgba(33,69,215,0.14)] backdrop-blur-sm">
        <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-muted text-primary">
          <CircleAlert className="size-9" />
        </div>
        <p className="mb-2 text-sm font-semibold tracking-[0.3em] text-primary/80">
          {t('eyebrow')}
        </p>
        <h1 className="mb-3 text-2xl font-bold text-secondary">{t('title')}</h1>
        <p className="mb-8 text-sm leading-7 text-muted-foreground">
          {t('description')}
        </p>
        <Button className="w-full" size="lg" onClick={handleRecover}>
          <ArrowRight className="size-4" />
          {t('action')}
        </Button>
      </div>
    </Container>
  );
};

export default NotFoundPage;
